
<template>
  <div style="background-color: rgba(236, 243, 255, 1);">
    <section class="section">
      <div style="display: flex;justify-content: center;margin-top: 35px;margin-bottom: 30px">
        <h2 class="section-title">合作项目</h2>
      </div>
      <div class="feature-container">
        <div class="feature-item">
          <div class="feature-img">
            <img src="./assets/img/cart1.png" alt="智能工厂">
          </div>
          <div class="feature-text">
            <h3>坤盈数科-企业数字化研发底座</h3>
            <p>一款旨在帮助企业落地真正适合自己的数字化解决方案的平台产品。将企业数字化解决方案转化为企业资产，并提供与之配套的社区生态。深度挖掘AI在企业数字化应用场景中可以发挥的价值，使AI赋能企业不止停留在概念上。让不同能力背景的用户都能找到适合自己的应用开发工具。</p>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-img">
            <img src="./assets/img/cart2.png" alt="生产优化">
          </div>
          <div class="feature-text">
            <h3>赛郎特-智慧生产管理和流程信息化</h3>
            <p> 赛郎特容器科技(滁州)有限公司借助信息化和智能化手段，提升生产效率与管控水平。生产全程实现数字化、标准化管理，推动智能化升级。以生产管控为核心，围绕牢控进度、提高效率，全力推进信息化与智能化建设。实施时，将全量工艺流程纳入系统，形成数据资产，以模板绑定生产工单，赋予工单完整流程节点。针对无特殊工艺要求或标准化产品工单，系统自动引入标准流程，确保各节点依流程执行。</p>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-img">
            <img src="./assets/img/cart3.png" alt="仓储物流">
          </div>
          <div class="feature-text">
            <h3>滁州城市职业学院-科技创新与教育资源的深度融合</h3>
            <p> 科技与教育融合赋能区域产业升级和人才储备。滁州城市职业学院与明晟智能产业研究院联合实施"明晟冠名班"专项人才培养计划，同步建设数据标注中心：该中心依托AI及大数据技术，重点提升图像、语音、自然语言处理等领域数据标注能力，同步构建AI技术应用转化平台，助力企业智能化升级。</p>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div style="display: flex;justify-content: center;margin-top: 35px;margin-bottom: 30px">
        <h2 class="section-title">联合实验室</h2>
      </div>
      <div class="feature-container">
        <div class="feature-item">
          <div class="feature-img">
            <img src="./assets/img/cart5.png" alt="智能工厂">
          </div>
          <div class="feature-text">
            <h3>明晟人工智能产业研究院-滁州电信联合实验室</h3>
            <p>明晟人工智能产业研究院与滁州电信2024年底共建联合实验室，整合5G/AI/大数据/物联网/边缘计算等技术，驱动产业创新升级。该实验室通过技术研发与场景化应用，为企业提供数字化转型解决方案，同步推进智慧城市建设；并搭建产学研平台，通过学术交流与人才培养加速成果转化，赋能区域经济高质量发展。</p>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-img">
            <img src="./assets/img/MasterDDSSlicePNGff87d95f8098ef8ffa0ffa4b0f27af11.png" alt="生产优化">
          </div>
          <div class="feature-text">
            <h3>明晟人工智能产业研究院-湖北大学</h3>
            <p>2025年计划成立的明晟人工智能产业研究院与湖北大学实验室硕士联培计划，整合双方在人工智能等领域优势，共育高层次专业人才。明晟研究院为湖北大学硕士研究生提供实践平台，学生在技术团队指导下参与前沿技术研发与产业化应用，积累实战经验。该计划借产学研融合，既为学生提供创新项目研究机会，推动技术成果转化助力企业升级，又能为地方企业输送人才，强化校企合作，促进科技创新与地方经济发展。</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
}
</script>

<style scoped lang="css">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", sans-serif;
}

body {
  background-color: #f5f9ff;
  color: #333;
  line-height: 1.6;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 50px;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.logo {
  height: 40px;
}

.nav {
  display: flex;
  gap: 20px;
}

.nav-item {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}


.banner h1 {
  background-image: linear-gradient(45deg, rgba(7, 103, 252, 1) 0, rgba(22, 237, 140, 1) 100%);
  //width: 205px;
  height: 56px;
  overflow-wrap: break-word;
  font-size: 50px;
  font-family: Alimama ShuHeiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 56px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 20px;

}

.banner p {
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  text-align: left;
}

.banner-img {
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.floating-element {
  position: absolute;
  opacity: 0.6;
  z-index: 1;
}

.floating-1 {
  top: 10%;
  left: 10%;
  animation: float 8s ease-in-out infinite;
}

.floating-2 {
  bottom: 15%;
  right: 10%;
  animation: float 10s ease-in-out infinite;
}

.floating-3 {
  top: 60%;
  left: 15%;
  animation: float 12s ease-in-out infinite;
}

@keyframes float {
  0% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(5deg); }
  100% { transform: translateY(0) rotate(0deg); }
}

.section {
  padding: 20px 0;
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 32px;
  color: #181F5C;
  margin-bottom: 20px;
  position: relative;
  text-align: center;
  font-family: "Alimama ShuHeiTi-Bold";
}
.section-title:before{
  left: -135px !important;
}
.section-title:after{
  right: -135px !important;
}
.section-title:before {
  content: "";
  background-image: url('assets/img/title-icon-left.png');
  position: absolute;
  width: 112px;
  height: 59px;
  //background-color: #0052d9;
  bottom: -10px;

  //transform: translateX(-50%);
}
.section-title:after {
  content: "";
  background-image: url('assets/img/title-icon-right.png');
  position: absolute;
  width: 112px;
  height: 59px;
  //background-color: #0052d9;
  bottom: -10px;
  right: 185px;
  //transform: translateX(-50%);
}

.card-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 30px auto;
  flex-wrap: wrap;
}

.card {
  //background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  width: 386px;
  text-align: left;
  transition: transform 0.3s ease;
}

.card-img {
  //width: 100%;
  ////height: 200px;
  //object-fit: cover;
}

.card-content {
  //width: 386px;
  height: 212px;
  background: linear-gradient( 180deg, #ECF1F9 0%, #FEFEFF 100%);
  border-radius: 0px 0px 0px 0px;
  //border: 1px solid #FFFFFF;
  padding: 20px;
}

.card h3 {
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  font-family: "Alimama ShuHeiTi-Bold";
  //margin-top: 10px;
}

.card p {
  width: 346px;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  margin-top: 20px;
}

.feature-section {
  background-color: #fff;
  padding: 40px 0;
}

.feature-container {
  max-width: 1200px;
  margin: 0 auto;
}

.feature-item {
  display: flex;
  margin-bottom: 10px;
  //align-items: center;
}

.feature-item:nth-child(even) {
  flex-direction: row-reverse;
}

.feature-img {
  flex: 1;
  padding: 20px;
}

.feature-img img {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.feature-text {
  flex: 1;
  padding: 20px;
  text-align: justify;
}

.feature-text h3 {
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  font-family: "Alimama ShuHeiTi-Bold";
}

.feature-text p {
  width: 560px;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  margin-top: 20px;
}

.solution-section {
  //padding: 40px 0;
  //background-color: #f5f9ff;
}

.solution-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.solution-item {
  //width: 48%;
  //background-color: #fff;
  //border-radius: 10px;
  //padding: 20px;
  //margin-bottom: 20px;
  //box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  //text-align: left;
  margin-bottom: 20px;
}
.solution-item div:nth-child(1){
  width: 590px;
  height: 50px;
  background: linear-gradient( 45deg, #0767FC 0%, rgba(7,103,252,0) 100%);
  border-radius: 0px 0px 0px 0px;
  display: flex;
  align-items: center;
}
.solution-item div:nth-child(2){
  width: 590px;
  height: 284px;
  background: linear-gradient( 180deg, #ECF1F9 0%, #FEFEFF 100%);
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #FFFFFF;
  display: flex;
  align-items: center;
  padding: 20px;
}
.solution-item h3 {
  font-weight: 700;
  font-size: 24px;
  color: #FFFFFF;
  font-family: "Alimama ShuHeiTi-Bold";
  margin-left: 20px;
}


.solution-item p {
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  width: 590px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 10px;
}

.footer {
  background-color: #0066cc;
  color: white;
  padding: 40px 0;
}

.footer-container {
  display: flex;
  justify-content: space-around;
  max-width: 1200px;
  margin: 0 auto;
  flex-wrap: wrap;
}

.footer-column {
  flex: 1;
  min-width: 200px;
  margin: 10px;
}

.footer-column h3 {
  margin-bottom: 20px;
  font-size: 18px;
}

.footer-column p, .footer-column a {
  color: #e6f0ff;
  text-decoration: none;
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
}

.qrcode {
  width: 100px;
  height: 100px;
  margin-top: 10px;
}
</style>
